import React from 'react';

const Footer = () => {
    return (
        <footer> 
            <p>&copy; 2024 Sleepless in Seattle</p>
        </footer>
    );
};

export default Footer;
